import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
function CustomBox({children}) {
   if (typeof children === 'string') {
      return (
         <Box p={1}>
            <Typography>{children}</Typography>
         </Box>
      );
   }
   return <Box p={1}>{children}</Box>;
}
function TabPanel(props) {
   const {children, value, index, ...other} = props;
   return (
      <div
         role="tabpanel"
         hidden={value !== index}
         id={`vertical-tabpanel-${index}`}
         aria-labelledby={`vertical-tab-${index}`}
         aria-controls={`vertical-tabpanel-${index}`}
         {...other}
      >
         {value === index && <CustomBox>{children}</CustomBox>}
      </div>
   );
}
export function a11yProps(index) {
   return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`
   };
}
export default TabPanel;
